import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDButton from "theme/components/MDButton";
import { useAwaitDialog } from "app/components/status_dialog";

function CommunicationCeneterPage() {
  const pageTitle = "Laddar - Business Communications";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [pageLoaded, setPageLoaded] = useState(true);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={1}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>perm_phone_msg</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Business Communication Center
                      </MDTypography>
                      {/* <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={16}>
                        Transform your business calls with LaddarVoice
                        <br />
                        Monitor calls, track team performance and access AI powered call analytics.
                      </MDTypography> */}
                    </MDBox>
                    <MDBox mt={5} align="center" mb={3}>
                      <Grid
                        container
                        spacing={{
                          xs: 2,
                          md: 4,
                          lg: 4,
                        }}
                        justifyContent="center"
                        sx={{ margin: "0 auto" }}
                      >
                        <Grid item xs={6} md={5} lg={5}>
                          <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                            <MDBox
                              p={2}
                              onClick={() => {
                                navigate("/voice-os");
                              }}
                            >
                              <MDTypography variant="h6" fontSize={24}>
                                <Icon>phone</Icon>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={16}>
                                Voice
                              </MDTypography>
                              <MDTypography variant="body2" fontWeight="light" fontSize={16}>
                                Monitor, manage and transform your business calls with Laddar Voice
                              </MDTypography>
                              <MDBox mt={3}>
                                <MDButton
                                  variant="contained"
                                  color="dark"
                                  onClick={() => {
                                    navigate("/voice-os");
                                  }}
                                  iconOnly
                                >
                                  <Icon>east</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </Grid>
                        <Grid item xs={6} md={5} lg={5}>
                          <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                            <MDBox
                              p={2}
                              onClick={() => {
                                navigate("/wacc");
                              }}
                            >
                              <MDTypography variant="h6" fontSize={24}>
                                <Icon>forum</Icon>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={16}>
                                Whastapp
                              </MDTypography>
                              <MDTypography variant="body2" fontWeight="light" fontSize={16}>
                                Manage your business' communication on Whatsapp seamlessly.
                              </MDTypography>
                              <MDBox mt={3}>
                                <MDButton
                                  variant="contained"
                                  color="dark"
                                  onClick={() => {
                                    navigate("/wacc");
                                  }}
                                  iconOnly
                                >
                                  <Icon>east</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CommunicationCeneterPage;
